import * as React from 'react';

import loaderUrl from '../../../assets/images/LoaderAutoCut.gif';

import css from './LoaderAutocut.module.scss';

const loader = new URL(loaderUrl, import.meta.url).href;

interface LoaderProps {
  isLoading?: boolean;
  height: number;
  /** 0–100 percent; ring hidden at 0 */
  progress?: number;
}

const PROGRESS_MASK_CIRCLE_RADIUS = 50;
const PROGRESS_MASK_CIRCLE_STROKE_DASH_ARRAY_VALUE = Math.round(
  2 * Math.PI * PROGRESS_MASK_CIRCLE_RADIUS + 0.1
);
const PROGRESS_MASK_CIRCLE_STROKE_DASH_OFFSET_1_PERCENT_VALUE =
  PROGRESS_MASK_CIRCLE_STROKE_DASH_ARRAY_VALUE / 100;

export const LoaderAutocut = ({
  isLoading = true,
  height,
  progress = 0,
}: LoaderProps) => {
  const progressMaskStrokeDashOffset =
    PROGRESS_MASK_CIRCLE_STROKE_DASH_ARRAY_VALUE -
    PROGRESS_MASK_CIRCLE_STROKE_DASH_OFFSET_1_PERCENT_VALUE * progress;
  const progressMaskImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='none' stroke='white' stroke-width='40' stroke-dasharray='${PROGRESS_MASK_CIRCLE_STROKE_DASH_ARRAY_VALUE}' stroke-dashoffset='${progressMaskStrokeDashOffset}' /%3E%3C/svg%3E")`;

  return (
    <div className={css.loader}>
      {isLoading ? (
        <div className={css.loaderWrapper}>
          {progress ? (
            <div
              className={css.progressRing}
              style={{
                WebkitMaskImage: progressMaskImage,
                maskImage: progressMaskImage,
              }}
            />
          ) : null}
          <img
            height={height}
            src={loader}
            alt="loader"
            className={css.loaderImage}
          />
        </div>
      ) : null}
    </div>
  );
};
